module.exports = __webpack_public_path__ + "img/check-done-01.dcc56c61.svg";